import styled from 'styled-components';

export const WalletWrap = styled.div`
  width: 100%;
  display: flex;
  padding: 16px;
  background-image: linear-gradient(83deg, #c86dd7 1%, #3023ae 100%);
  align-items: center;
`;

export const BackIconWrap = styled.div(
  props =>`
    padding: ${props.theme.spacing.base};
  `
)

export const  WallectBlc = styled.div`
  width: 80%;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const Amount = styled.p`
  text-align:center;
  font-size: 25px;
  color: #fff;
  font-weight: 900;
  margin-bottom: 5px;
`;

export const Text = styled.p`
  font-size: 14px;
  color: rgba(254, 254,254, 0.5);
  text-align:center;
  text-transform: uppercase;
  font-weight: 900;
`;

export const WalletCashTextLoader = styled.div(
  props => `
    background-image: linear-gradient(83deg,#c86dd7 1%,#3023ae 100%);
    width: 10rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  `
);